/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbMetierClauseLiesGridDto } from './FcbMetierClauseLiesGridDto';
import {
    FcbMetierClauseLiesGridDtoFromJSON,
    FcbMetierClauseLiesGridDtoFromJSONTyped,
    FcbMetierClauseLiesGridDtoToJSON,
} from './FcbMetierClauseLiesGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbMetierClauseLiesGridDtoPaginatedResults
 */
export interface FcbMetierClauseLiesGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbMetierClauseLiesGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbMetierClauseLiesGridDto>}
     * @memberof FcbMetierClauseLiesGridDtoPaginatedResults
     */
    results?: Array<FcbMetierClauseLiesGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbMetierClauseLiesGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbMetierClauseLiesGridDtoPaginatedResults interface.
 */
export function instanceOfFcbMetierClauseLiesGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbMetierClauseLiesGridDtoPaginatedResultsFromJSON(json: any): FcbMetierClauseLiesGridDtoPaginatedResults {
    return FcbMetierClauseLiesGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbMetierClauseLiesGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbMetierClauseLiesGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbMetierClauseLiesGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbMetierClauseLiesGridDtoPaginatedResultsToJSON(value?: FcbMetierClauseLiesGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbMetierClauseLiesGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

